export default __webpack_public_path__ + "media/images/coworkr/favicons/icon310-8a4d3ca642c1cacf88158c3132a02ab3.png";